<script setup lang="ts">
/**
 * Action posée sous une liste, à la forme d'un item vide : pleine largeur,
 * très discrète, elle prolonge la liste au lieu de rivaliser avec elle.
 */

withDefaults(
  defineProps<{
    icon: string;
    label: string;
    disabled?: boolean;
    loading?: boolean;
  }>(),
  { disabled: false, loading: false }
);

defineEmits<{
  (e: "click"): void;
}>();
</script>

<template>
  <button
    type="button"
    class="placeholder-action"
    :disabled="disabled || loading"
    @click="$emit('click')"
  >
    <span
      v-if="loading"
      class="spinner-border spinner-border-sm"
      role="status"
    />
    <i v-else :class="icon" />
    <span class="label">{{ label }}</span>
  </button>
</template>

<style lang="scss" scoped>
.placeholder-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 9px 12px;
  border: 1px dashed var(--bs-border-color);
  border-radius: 8px;
  background: none;
  color: var(--bs-secondary-color);
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease,
    background-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: var(--bs-secondary-color);
    color: var(--bs-body-color);
    background-color: var(--bs-tertiary-bg);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
